import React, {ReactElement, useCallback, useEffect, useRef, useState} from "react";

export default function ZeeroInlineTextCell({value, secret, onChange, original}: {
	value: string | null;
	secret?: boolean;
	original: string | null;
	onChange: (next: string | null) => void;
}): ReactElement {
	const [isEditing, setIsEditing] = useState(false);
	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (isEditing && inputRef.current) {
			inputRef.current.focus();
		}
	}, [isEditing]);

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			(e.target as HTMLInputElement).blur();
		} else if (e.key === "Escape") {
			onChange(original);
			(e.target as HTMLInputElement).blur();
		}
	};

	const renderDisplay = useCallback(() => {
		if (value == null || value.length == 0) return <div><i>null</i></div>;
		if (secret) {
			const len = value.length;
			return <div>{len > 0 ? "•".repeat(len) : <i>empty</i>}</div>;
		}
		return <div>{value}</div>;
	}, [value, secret]);

	return (
			<div className="data-row-entry">
				{isEditing ? (
						<input
								ref={inputRef}
								type={secret ? "password" : "text"}
								value={value ?? ""}
								onChange={(e) => onChange(e.target.value)}
								onBlur={() => setIsEditing(false)}
								onKeyDown={handleKeyDown}
								className="zeero-input"
						/>
				) : (
						<div className="config-inline-display" onClick={() => setIsEditing(true)}>
							{renderDisplay()}
						</div>
				)}
			</div>
	);
}
